const aspectRatio = "zyoa1fajvqv";
const appletContainer = "zyoa1aapci1";

export { appletContainer, aspectRatio };
import "./_content.style.linaria.module.css";
//# sourceMappingURL=_content.style.js.map
